import { render } from "./BalancePage.vue?vue&type=template&id=6be04a2c&ts=true"
import script from "./BalancePage.vue?vue&type=script&lang=ts"
export * from "./BalancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__